import api from './index';
import { fetchReadableStream } from './fetchReadableStream';

const BASE = '/locationDelta';

export const uploadLocationDeltas = async ({
    dataToUpload,
    monthForUploading,
    setPercentage,
}: {
    dataToUpload: unknown;
    monthForUploading: string;
    setPercentage: (percentage: number) => void;
}) => {
    return await fetchReadableStream(`${BASE}`, { dataToUpload, monthForUploading }, setPercentage);
};

export const getAllLocationDeltaByFilters = async (
    dateFrom: string,
    dateTo: string,
    location: number,
    worktype: number,
    channel: number
) => {
    return api
        .get(`${BASE}/getAllLocationDeltaByFilters`, {
            params: { dateFrom, dateTo, location, worktype, channel },
        })
        .then((res) => res.data);
};

export const getAllLocationDeltaByBookingId = async (bookingId: number) => {
    return api.get(`${BASE}/getAllLocationDeltaByBookingId`, { params: { bookingId } }).then((res) => res.data);
};

export const getLocationDeltaForExcelExport = async (dateFrom: string, dateTo: string) => {
    return api.get(`${BASE}/getLocationDeltaForExcelExport`, { params: { dateFrom, dateTo } }).then((res) => res.data);
};

export const getLocationDeltaByDateRangeLocationAndWorktype = async (
    dateFrom: string,
    dateTo: string,
    location: number,
    worktype: number
) => {
    return api
        .get(`${BASE}/getLocationDeltaByDateRangeLocationAndWorktype`, {
            params: { dateFrom, dateTo, location, worktype },
        })
        .then((res) => res.data);
};

export const getLastLocationDeltaUploadDate = async (location: number): Promise<string> => {
    return api.get(`${BASE}/lastUploadDate`, { params: { location } }).then((res) => res.data);
};

export const getLatestLocationDeltaUploadDateForAllLocations = async () => {
    return api.get(`${BASE}/latestLocationDeltaUploadForAllLocations`).then((res) => res.data);
};

export const getLatestLocationDeltas = async ({
    dateFrom,
    dateTo,
    location,
    worktype,
    channel,
}: {
    dateFrom: string;
    dateTo: string;
    location: number;
    worktype: number;
    channel: number;
}) => {
    return api
        .get(`${BASE}/latest`, { params: { dateFrom, dateTo, location, worktype, channel } })
        .then((res) => res.data);
};
